export interface VolunteerCategory {
  id: string;
  label: string;
}

export const VOLUNTEER_CATEGORIES: VolunteerCategory[] = [
  { id: 'hospitality', label: 'Hospitality' },
  { id: 'children', label: 'Children' },
  { id: 'worship', label: 'Worship' },
  { id: 'outreach', label: 'Outreach' },
  { id: 'technical', label: 'Technical' },
  { id: 'prayer', label: 'Prayer' },
];
